// useLanguage.js
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
import store from '@/store/store';
import { getUrlLang } from '@/utils/commonUtils';
/**
 * 언어설정 관련 
 * 2025.01.19 saylee
 * 해당 hook 에서  언어 설정관련을 공통으로 여기서 꺼내서 사용하시오
 */
export function useLanguage() {
  const { t, locale } = useI18n();



  /**
   * 다국어 변경처리 함수
   * @param {*} lang  변경할 언어 ko , en 등
   * @param {*} isRefresh  변경후 새로고침 여부
   */
  const setLanguage = async (lang, isRefresh) => {
    locale.value = lang; // i18n 다국어 변경
    // alert("변경함수")
    if (isRefresh) {
      window.location.reload();
    }
  };

  /**
   * 경로에 맞는 언어를 확인하고 언어가 다르면 변경하는 함수
   */
  const getBeforeCheckLang = async () => {
    let defaultLang = store.state.locales?.lang;
    let lang = getUrlLang(defaultLang);

    if (lang !== locale.value) {
      // await store.dispatch('locales/setLang', lang);
    }
    return lang;
  };

  return {
    setLanguage,
    // getLangUrl,
    getBeforeCheckLang,
    t, // t 함수도 외부에서 사용하려면 리턴값에 포함
  };
}